// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3shH7","calendarButtons":"ClockData_calendarButtons__UDCSg"};